import React from "react";
import { usePlannerContext } from "./PlannerContext";
export default function BoardRow({block, visibleRoleKeys = [], roleOptions, dailyByBlockRole = {},
  PlannerShiftCard, LifecycleBoxes, cardHeightForCount, visibleCardsForCount, openOverflow = () => {}}) {
  const {selectedShiftId, selectedShiftIds, toggleShiftSelection, setSelectedShiftId, workersByUid, shortWorkerLabel, now} = usePlannerContext();
  return <>{visibleRoleKeys.map(rk => {
    const label = roleOptions?.map?.get(rk) || rk;
    const list = dailyByBlockRole?.[block.key]?.[rk] || [];
    const count = Math.min(3, visibleCardsForCount ? visibleCardsForCount(list.length) : list.length);
    const visible = list.slice(0,count);
    const hidden = list.length - visible.length;
    return <div key={block.key+'-'+rk} className="schedule-grid-cell" aria-label={label+' · '+block.label}>
      {!list.length && <span className="schedule-empty-cell">—</span>}
      {visible.map(shift => <PlannerShiftCard key={shift.id} shift={shift} now={now}
        selectedShiftId={selectedShiftId} selectedShiftIds={selectedShiftIds} toggleShiftSelection={toggleShiftSelection}
        setSelectedShiftId={setSelectedShiftId} workersByUid={workersByUid} shortWorkerLabel={shortWorkerLabel}
        LifecycleBoxes={LifecycleBoxes} compactHeight={cardHeightForCount ? cardHeightForCount(list.length) : undefined} />)}
      {hidden > 0 && <button type="button" className="schedule-overflow" onClick={() => openOverflow(block.label+' • '+label,list)}>+{hidden} more</button>}
    </div>;
  })}</>;
}
